import ListScroll from "../../ListScroll/ListScroll";

import ItemCard from "../../ListItem/ItemCard";
import "./Suggestions.css";

function Suggestions(props) {
    let items = props.suggestions;
    return (
        <div className='SuggestionsComponent'>
            <div className='caption'>
                <a href='/search?count=15&page=0&is_suggestion=true'>
                    پیشنهادات ویژه
                    <a
                        href='/search?count=15&page=0&is_suggestion=true'
                        className='all'
                    >
                        (مشاهده همه)
                    </a>
                </a>
            </div>
            <div className='SuggestionsContainer'>
                <ListScroll items={items} Component={ItemCard} key='id' />
            </div>
        </div>
    );
}

export default Suggestions;
